export default "__VITE_ASSET__f784ae90__"